// ======================================================================
// File Name       : MainContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Loadable from 'react-loading-overlay';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { checkLogin, logout } from '../actions/AuthAction';
import { DEV_MODE, STATUS_CD, SUPER_USER, LO_SUPER_USER, ADMIN_OEM_LOGIN_URL } from '../constants';
import { PAYMENT_URL, CONTACT_URL} from '../constants';
import { CHANGE_PASSWORD, PREVIEW_EACH_QUESTION_ATTRIBUTE } from '../constants/PathConstants';
import { removeAllScriptExcludeBundleJS } from '../utils';
import * as SessionStorageUtils from '../utils/SessionStorageUtils';
import PageBody from './PageBodyContainer';
import PageHeader from './PageHeaderContainer';
import ContractImage from '../images/contract.png';
import DropDownIcon from '../images/icon/DropDown.svg';
import CalendarIcon from '../images/calendar.png';
import { handleChangePageTitle } from '../utils/PageUtils';
import { getLoginUrl } from '../utils/AuthedUtils';
import { AWS_UPLOADS, TOKEN, EDIT_ACCOUNT_TYPE } from '../constants/LocalStorageConstants';
import { CREDIT_CHECKED_FLAG_STATUS } from '../constants/EnterpriseConstants';

global.cookies = new Cookies();
class MainContainer extends Component {
  constructor() {
    super();
    this.state = {
      redirectToLogin: false,
      loading: false,
    };

    this.handleLogout = this.handleLogout.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidUpdate() {
    // if (DEV_MODE) {
    //   Perf.stop();
    //   Perf.printInclusive();
    //   Perf.printWasted();
    // }
  }

  componentWillMount() {
    if (!this.props.logined) {
      const self = this;
      this.props.dispatch(checkLogin()).then(() => {
        self.setState({ loading: true });
      });
    }

    // Step8.0.3 START
    handleChangePageTitle();
    this.unlisten = this.props.history.listen(() => handleChangePageTitle());
    // Step8.0.3 END
  }

  // Step8.0.3 START
  componentWillUnmount() {
    this.unlisten();
  }
  // Step8.0.3 END

  handleLogout() {
    // Step9.0.0 START
    const { authedUser: { isOEMUser } } = this.props;
    const loginUrl  = getLoginUrl(); 
    this.setState({
      ...this.state,
      isOEMUser,
      loginUrl,
    });
    // Step9.0.0 END
    this.props.dispatch(logout()).then(() => {
      SessionStorageUtils.clear();
      // #7232 START
      // #7287 START
      removeAllScriptExcludeBundleJS();
      // #7287 END
      // #7232 END
      // STEP9.0.0 START
      // Step 10.0.0 START
      localStorage.removeItem(TOKEN);
      localStorage.removeItem(AWS_UPLOADS);
      localStorage.removeItem(EDIT_ACCOUNT_TYPE); // STEP 12.0.0
      window.clearCorsToken();
      // Step 10.0.0 END
      // STEP9.0.0 END
      window.location.href = loginUrl; // Step9.0.0
    });
  }

  scrollToTop() {
    const body = $('#sroll-container');
    body.stop().animate({ scrollTop: 0 }, 300, 'swing');
  }

  render() {
    const { match, logined, statusCd, location, showLoading, passwordChangeFlag, authedUser, editingEnterprise } = this.props;
    const { url } = match;
    const { hideTopMenu, showContentsOnly } = SessionStorageUtils.storeUserQuery(location);
    const isShowHeader = (url !== PREVIEW_EACH_QUESTION_ATTRIBUTE);
    // Step 9.0.0 START
    const isOEMUser = authedUser && authedUser.isOEMUser || this.state.isOEMUser;
    const loginUrl = authedUser && getLoginUrl() || this.state.loginUrl;
    // Step 9.0.0 END
    if ((this.state.loading && !logined) || statusCd === STATUS_CD.LOGIN_ERROR) {
      // Step 9.0.0 START
      window.location.href = loginUrl; // Step 11.0.0
      // Step 9.0.0 END
    }
    const { isShowContractRegion, isTrialExpire, isShowMsgAfterTrialExpired, remainTrialDays} = authedUser;
    const { displayUserType } = authedUser.userInfo;
    const isSuperUserL0 = [LO_SUPER_USER].indexOf(displayUserType) > -1;
    // sprint_20230605_tma START
    const isShowContract =
      (!isSuperUserL0 && isShowContractRegion) ||
      (isShowMsgAfterTrialExpired && [SUPER_USER].indexOf(displayUserType) > -1);
    const isShowRemainDays = typeof remainTrialDays !== 'undefined' && !isSuperUserL0 && isShowContractRegion;
    // sprint_20230605_tma END
    const isCreditCheckedFlagNoProblem =
      editingEnterprise &&
      editingEnterprise.creditCheckedFlag ===
        CREDIT_CHECKED_FLAG_STATUS.NO_PROBLEM;

    return this.props.logined
      ? <Loadable
        active={showLoading}
        spinner
        style={{
          minHeight: '100vh',
        }}
        zIndex={10000}
      >
        <div id="sroll-container" style={{ height: '100%' }}>
          <PageHeader {...this.props} logout={this.handleLogout} isShowContract={isShowContract} isSuperUserL0={isSuperUserL0}  isTrialExpire={isTrialExpire} />
          <PageBody {...this.props} logout={this.handleLogout} hideTopMenu={hideTopMenu} showContentsOnly={showContentsOnly} isShowContract={isShowContract} isSuperUserL0={isSuperUserL0} isTrialExpire={isTrialExpire} />
          {/* sprint_20230731_tma START*/}
          {isShowContract && (
            <>
            <div className="contract-btn-container inquiry-region padding-left-right-clear bottom-right z-index-1000">
                <div className='text-right padding-right-10'>
                  <button type="button" className="drop-down-contract-btn" data-bs-toggle="collapse" data-bs-target="#contract-btn">
                    <img src={DropDownIcon} />
                  </button>
                </div>
                <ul className="inquiry-contract-container z-index-front">
                  {/* Sprint_20230605 START */}
                  {isShowRemainDays && (
                    <div className="remainDaysText">
                      トライアル期間 残り{<p className='font-size-130'>{remainTrialDays}</p>}日
                    </div>
                  )}
                  {/* Sprint_20230605 END */}
                  <div id="contract-btn" className="collapse show">
                    <a role="presentation">
                      <img src={ContractImage} alt="contractImage" />
                    </a>
                    {isCreditCheckedFlagNoProblem && (
                      <a role="presentation" href={`${PAYMENT_URL}`} target="_blank" className="inquiry-contract-btn bold">
                        契約手続きに進む
                      </a>
                    )}
                    <a role="presentation" href={`${CONTACT_URL}`} target="_blank" className="inquiry-contact-btn">
                      <img src={CalendarIcon} alt="CalendarIcon" className="padding-right-10" />
                      担当者と直接話す
                    </a>
                  </div>
                </ul>
              </div>
            </>
          )}
          {/* sprint_20230731_tma END*/}
        </div>
        <input onClick={this.scrollToTop} className="layout-scrollTop" id="scropToTop" />
      </Loadable>
      : <div />;
  }
}

MainContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { logined, authedUser } = state.authed;
  const { statusCd } = state.message;
  const { showLoading } = state.page;
  const { editingEnterprise } = state.enterprise;
  let passwordChangeFlag = 0;
  if (authedUser && authedUser.userInfo) {
    const { userInfo } = authedUser;
    passwordChangeFlag = userInfo.passwordChangeFlag || 0;
  }
  return { logined, statusCd, showLoading, passwordChangeFlag, authedUser, editingEnterprise };
};
export default connect(mapStateToProps)(MainContainer);
